module.exports = __webpack_public_path__ + "img/clip_image061.eecc4cd9.png";